/**
 * F6-Submitted — confirmation, turnaround promise, and "who referred you" capture.
 */
import { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

export function Submitted(): JSX.Element {
  const navigate = useNavigate();
  const location = useLocation();
  const [referrer, setReferrer] = useState('');

  return (
    <div className="flow flow--single">
      <div className="stage-card">
        <div className="pb-note pb-note--good" role="status">
          Got it &mdash; your photos are in.
        </div>
        <h1>We&rsquo;ll come back by the next business day.</h1>
        <p className="stage-card__lede">
          A real person looks at what you sent and comes back with your free estimate. If it
          doesn&rsquo;t work for you, that&rsquo;s where it ends &mdash; nothing owed.
        </p>

        <div className="pb-surface">
          <label className="pb-label" htmlFor="ref">
            Anyone we should thank for sending you our way?
          </label>
          <input
            id="ref"
            className="pb-field"
            placeholder="A name, or leave it blank"
            value={referrer}
            onChange={(e) => setReferrer(e.target.value)}
          />
        </div>

        <div className="q-actions">
          <button
            type="button"
            className="pb-btn pb-btn--next pb-btn--lg"
            onClick={() => navigate('/range', { state: location.state })}
          >
            Start my free estimate
          </button>
        </div>
        <p className="estimate__hint">
          In the real flow this continues by email. Here it&rsquo;s shown straight away.
        </p>
      </div>
    </div>
  );
}
